// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/**\n * 全局变量\n * 命名规范 —— 遵守语义化命名：lg-大号、md-中号、base-基本号、sm-小号、mini-超小号\n */\n.app-wrapper[data-v-13877386] {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  /* padding-top: 46px; */\n}\n.app-wrapper[data-v-13877386]:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.mobile .fixed-header[data-v-13877386] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
